import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const RadioWesterPoint = ({ enabledWesterPoint, usePoint, westerPointValidationError, onChange }) => {
  const [inputValue, setInputValue] = useState(String(usePoint ? usePoint : 0));

  useEffect(() => {
    if (enabledWesterPoint) {
      setInputValue(String(usePoint ? usePoint : 0));
    } else {
      setInputValue('');
    }
  }, [enabledWesterPoint, usePoint]);

  const handleBlur = (value) => {
    const numeric = value === '' ? 0 : Number(value);
    const sanitized = Number.isNaN(numeric) ? 0 : numeric;
    setInputValue(String(sanitized));
    onChange({ enabledWesterPoint: true, usePoint: sanitized });
  };

  return (
    <div className="radio RadioCash">
      <div className="radioItem" onClick={() => {
        onChange({ enabledWesterPoint: false, usePoint: 0 });
      }}>
        <input type="radio" name="radio-wester-point-1" className="radio-input" id="westerPoint-1" checked={!enabledWesterPoint} readOnly />
        <label htmlFor="westerPoint-1">WESTERポイントを使わない</label>
      </div>
      <div className="radioItem" onClick={() => onChange({ enabledWesterPoint: true, usePoint: usePoint || 0 })}>
        <input type="radio" name="radio-wester-point-2" className="radio-input" id="westerPoint-2" checked={enabledWesterPoint} readOnly />
        <label htmlFor="westerPoint-2">WESTERポイントを使う</label>
      </div>

      {enabledWesterPoint &&<div className="userInfoWesterPointInput pageEntry">
        <div className="inputWesterPoint">
          <input
            id="input.wester.point"
            type="number"
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onBlur={(e) => {
              handleBlur(e.target.value);
            }}
            className={`westerPointInput ${westerPointValidationError ? 'hasError' : ''}`}
          />
          <label htmlFor="input.wester.point">ポイント</label>
        </div>
        {westerPointValidationError && <div className="userInfoWesterPointValidationError">{westerPointValidationError}</div>}
      </div>}
    </div>
  );
};

RadioWesterPoint.defaultProps = {
  usePoint: 0,
  westerPointValidationError: '',
};

RadioWesterPoint.propTypes = {
  enabledWesterPoint: PropTypes.bool.isRequired,
  usePoint: PropTypes.number,
  westerPointValidationError: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default RadioWesterPoint;
